import styled from "styled-components";
import * as variables from "src/styles/variables.scss";

const Label = styled("label")`
    color: ${variables.colorBase};
    display: inline-block;
    font-size: 14px;
    width: 100%;
`;

export default Label;
